import {Action, Dispatch} from 'redux';
import {showError} from './Common';
import {ApiActionCall, ApiActionTypes} from './Api';
import {
  FreeMetaTransactionsActionTypes,
  FETCH_FREE_META_TRANSACTIONS,
  FETCH_FREE_META_TRANSACTIONS_SUCCESS,
  FETCH_FREE_META_TRANSACTIONS_ERROR,
} from '../../types/actions/FreeMetaTransactions.actions';
import {FREE_META_TRANSACTIONS_URL} from '../../@crema/services/ApiConfig';
import {IBuyback} from '../../types/models/Price';
import {logger} from '../../shared/logger';

export const fetchFreeMetaTransactionsStatus = () => async (
  dispatch: Dispatch<ApiActionCall | FreeMetaTransactionsActionTypes>,
) => {
  dispatch({type: FETCH_FREE_META_TRANSACTIONS});

  const onSuccess = (payload: IBuyback) => ({
    type: FETCH_FREE_META_TRANSACTIONS_SUCCESS,
    payload,
  });
  const onFailure = (message: string) => (dispatch: Dispatch<Action>) => {
    logger.error(message);
    dispatch({type: FETCH_FREE_META_TRANSACTIONS_ERROR});
    dispatch(showError('Failed to fetch free meta transactions data.'));
  };

  dispatch({
    type: ApiActionTypes.API_CALL,
    payload: {
      url: FREE_META_TRANSACTIONS_URL,
      method: 'GET',
      label: 'Fetch free meta transactions',
      onSuccess,
      onFailure,
    },
  });
};
